export class PermissionsModel {
  canEditMenuReturns: boolean
  canEditRoute: boolean
  canEditEmployee: boolean
  canEditDeliverSells: boolean
  hasDeliversSellsAccess: boolean
  hasEmployeesAccess: boolean
  hasRoutesAccess: boolean
  hasMenuReturnsAccess: boolean
  hasMenuReturnsReportAccess: boolean
  canEditMenuReturnsReport: boolean
  hasRewardsAccess: boolean
  canEditRewards: boolean
  hasChangeLogAccess: boolean
  hasLocalizationAccess: boolean
  canDisableDeliverSells: boolean
  hasDocumentsAccess: boolean
  hasDeliversOrdersAccess: boolean
  hasMenuAccess: boolean
  canEditMenu: boolean

  constructor(data: Partial<PermissionsModel>) {
    this.canEditMenuReturns = data.canEditMenuReturns || false
    this.canEditRoute = data.canEditRoute || false
    this.canEditEmployee = data.canEditEmployee || false
    this.canEditDeliverSells = data.canEditDeliverSells || false
    this.hasDeliversSellsAccess = data.hasDeliversSellsAccess || false
    this.hasEmployeesAccess = data.hasEmployeesAccess || false
    this.hasRoutesAccess = data.hasRoutesAccess || false
    this.hasMenuReturnsAccess = data.hasMenuReturnsAccess || false
    this.hasMenuReturnsReportAccess = data.hasMenuReturnsReportAccess || false
    this.canEditMenuReturnsReport = data.canEditMenuReturnsReport || false
    this.hasRewardsAccess = data.hasRewardsAccess || false
    this.canEditRewards = data.canEditRewards || false
    this.hasChangeLogAccess = data.hasChangeLogAccess || false
    this.hasLocalizationAccess = data.hasLocalizationAccess || false
    this.canDisableDeliverSells = data.canDisableDeliverSells || false
    this.hasDocumentsAccess = data.hasDocumentsAccess || false
    this.hasDeliversOrdersAccess = data.hasDeliversOrdersAccess || false
    this.hasMenuAccess = data.hasMenuAccess || false
    this.canEditMenu = data.canEditMenu || false
  }

  toMap() {
    return {
      canEditMenuReturns: this.canEditMenuReturns || false,
      canEditRoute: this.canEditRoute || false,
      canEditEmployee: this.canEditEmployee || false,
      canEditDeliverSells: this.canEditDeliverSells || false,
      hasDeliversSellsAccess: this.hasDeliversSellsAccess || false,
      hasEmployeesAccess: this.hasEmployeesAccess || false,
      hasRoutesAccess: this.hasRoutesAccess || false,
      hasMenuReturnsAccess: this.hasMenuReturnsAccess || false,
      hasMenuReturnsReportAccess: this.hasMenuReturnsReportAccess || false,
      canEditMenuReturnsReport: this.canEditMenuReturnsReport || false,
      hasRewardsAccess: this.hasRewardsAccess || false,
      canEditRewards: this.canEditRewards || false,
      hasChangeLogAccess: this.hasChangeLogAccess || false,
      hasLocalizationAccess: this.hasLocalizationAccess || false,
      canDisableDeliverSells: this.canDisableDeliverSells || false,
      hasDocumentsAccess: this.hasDocumentsAccess || false,
      hasDeliversOrdersAccess: this.hasDeliversOrdersAccess || false,
      hasMenuAccess: this.hasMenuAccess || false,
      canEditMenu: this.canEditMenu || false,
    }
  }
}
